// Мост «pre-mount guard → MentorPage» для дедупа by-slug.
//
// resolveMentorSlug (router beforeEnter, Bug 4.2) уже тянет
// /public/mentors/by-slug/{slug}/ ради pre-mount 404-проверки и канонизации
// redirect_to. Раньше этот payload выбрасывался, а MentorPage.onMounted тянул
// ТОТ ЖЕ эндпоинт повторно — отсюда двойной вызов by-slug на загрузку страницы
// наставника (виден в HAR). Здесь гард (через обёртку fetcher'а в router/index.ts)
// кладёт payload, а MentorPage забирает его ОДИН раз: consume удаляет запись,
// поэтому кэш не может устареть и не мешает клиентским slug→slug переходам
// (на них beforeEnter не срабатывает — меняются только params — и MentorPage
// честно грузит сам, промаха по кэшу).

import type { MentorSlugPayload } from '@/router/guards';

const cache = new Map<string, MentorSlugPayload>();

/** Сохранить payload by-slug, добытый pre-mount гардом (пишет только гард). */
export function storeMentorSlugPayload(slug: string, payload: MentorSlugPayload): void {
    if (slug) {
        cache.set(slug, payload);
    }
}

/**
 * Забрать и удалить закэшированный payload (one-shot). Возвращает undefined,
 * если гард ничего не клал (клиентский переход / прямой заход) — вызывающий
 * тогда грузит сам.
 */
export function consumeMentorSlugPayload(slug: string): MentorSlugPayload | undefined {
    const payload = cache.get(slug);
    if (payload !== undefined) {
        cache.delete(slug);
    }
    return payload;
}
